import '../CSS/pages.css';

function About() {
  return (
    <main className="page">
      <section className="page-heading">
        <p className="eyebrow">About</p>
        <h1>Dispatch partnership with practical logistics discipline.</h1>
        <p>
          Emma Pro Logistixs is designed for carriers who need a dependable
          dispatch partner without losing control of their business. The focus is
          simple: understand your equipment, communicate clearly, and help you
          make better freight decisions.
        </p>
      </section>

      <section className="split-section">
        <div>
          <h2>What we focus on</h2>
          <p>
            The dispatch process centers on matching freight with your operating
            preferences, reducing deadhead, organizing load details, and keeping
            the day moving when plans change.
          </p>
        </div>
        <ul className="feature-list">
          <li>Owner-operator and carrier dispatch support</li>
          <li>Lane preference and equipment-aware load searches</li>
          <li>Broker communication and trip detail organization</li>
          <li>Consistent updates before pickup, in transit, and at delivery</li>
        </ul>
      </section>

      <section className="process-section">
        <h2>A simple working rhythm</h2>
        <div className="process-grid">
          <article>
            <h3>Understand</h3>
            <p>Review your truck, trailer type, lanes, schedule, and goals.</p>
          </article>
          <article>
            <h3>Plan</h3>
            <p>Find load options and compare the details that affect profit.</p>
          </article>
          <article>
            <h3>Coordinate</h3>
            <p>Help keep paperwork, calls, check-ins, and updates organized.</p>
          </article>
        </div>
      </section>
    </main>
  );
}

export default About;
